// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loader_loader__S7gdN","rotation":"Loader_rotation__ZEIo4"};